import React, { FC } from 'react';
import Typography from '@material-ui/core/Typography';

import {
  OlContainer,
  PageContent,
  PageSection,
  PageTitle,
  Paragraph,
} from './termsOfUse.styles';

type Props = {
  data: Record<string, never>
};

export const TermsOfUse = (props: Props) => {
  return (
    <PageSection position="topRight">
      <PageContent>
        <PageTitle variant="h1">{props.data.title ?? 'Home Stepper - Portal Terms of Use'}</PageTitle>
        <div dangerouslySetInnerHTML={{__html: props.data.content ?? ''}}></div>
      </PageContent>
    </PageSection>
  );
};
